module.exports = __webpack_public_path__ + "static/media/mobileScreenshot03.c78379f1.jpg";